__turbopack_context__.v({
  "amount": "ControlList-module-scss-module__qOuMQG__amount",
  "amount_caption": "ControlList-module-scss-module__qOuMQG__amount_caption",
  "disabled": "ControlList-module-scss-module__qOuMQG__disabled",
  "image": "ControlList-module-scss-module__qOuMQG__image",
  "left": "ControlList-module-scss-module__qOuMQG__left",
  "left_icon": "ControlList-module-scss-module__qOuMQG__left_icon",
  "left_icon_wrapper": "ControlList-module-scss-module__qOuMQG__left_icon_wrapper",
  "left_inner": "ControlList-module-scss-module__qOuMQG__left_inner",
  "mt": "ControlList-module-scss-module__qOuMQG__mt",
  "right": "ControlList-module-scss-module__qOuMQG__right",
  "right_amount": "ControlList-module-scss-module__qOuMQG__right_amount",
  "sub_text": "ControlList-module-scss-module__qOuMQG__sub_text",
  "title": "ControlList-module-scss-module__qOuMQG__title",
  "wrap": "ControlList-module-scss-module__qOuMQG__wrap",
});
